// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.herbivore-title{
    margin-top: 2vh;
}

.camera-card {
  width: 10vw;
}

.camera-name{
    font-size: 0.9rem;
    font-weight: 600;
}

.spinner-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.pagination-container {
  margin: 24px 0;
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Map/HerbivoreMap/HerbivoreOptions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".card-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.herbivore-title{\n    margin-top: 2vh;\n}\n\n.camera-card {\n  width: 10vw;\n}\n\n.camera-name{\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.spinner-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.pagination-container {\n  margin: 24px 0;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
